module.exports = __webpack_public_path__ + "static/media/Game2.2b20d450.svg";